// servizi/obiettivo.ts — v045: «Ti mancano X ⭐ per …»: il prossimo filtro da prendere con i crediti, da far vedere a
// fine partita (e nello Store). Prima quello che hai provato per ultimo nello Store (se non è già tuo), altrimenti il
// meno caro che non hai. Così ogni partita ha un traguardo vicino.
import { filtriDisponibili, profiloFiltri } from "./filtri.ts";
import { accessoFiltro } from "../filtri/accesso.ts";
import { testiFiltro } from "../filtri/registro.ts";
import { leggiPreferenza, salvaPreferenza } from "./preferenze.ts";
import { PREFERENZE } from "../costanti.ts";

export interface Obiettivo {
  id: string;
  nome: string;
  prezzo: number;
  /** quanti crediti mancano (0 = lo puoi già prendere) */
  mancano: number;
}

/** Il filtro provato per ultimo nello Store (il «desiderato»). */
export function segnaDesiderato(id: string): void {
  salvaPreferenza(PREFERENZE.filtroDesiderato, id);
}

export async function prossimoObiettivo(crediti: number, lingua: string): Promise<Obiettivo | null> {
  const filtri = await filtriDisponibili();
  const profilo = profiloFiltri();
  const daPrendere = filtri.filter((f) => f.prezzoCrediti > 0 && accessoFiltro(f, profilo) !== "libero").sort((a, b) => a.prezzoCrediti - b.prezzoCrediti || a.numero - b.numero);
  if (!daPrendere.length) return null;
  const desiderato = leggiPreferenza(PREFERENZE.filtroDesiderato);
  const scelto = daPrendere.find((f) => f.id === desiderato) ?? daPrendere.find((f) => f.prezzoCrediti > crediti) ?? daPrendere[0]!;
  const { nome } = await testiFiltro(scelto.id, lingua);
  return { id: scelto.id, nome, prezzo: scelto.prezzoCrediti, mancano: Math.max(0, scelto.prezzoCrediti - crediti) };
}
